module.exports = __webpack_public_path__ + "img/moveTo-Onhold.f19f2f69.svg";